/* eslint-disable perfectionist/sort-object-types */
export enum VoiceDictationResultAction {
	Initializing = 'Initializing',
	Uninitialized = 'Uninitialized',
	Unsupported = 'Unsupported',
	Recording = 'Recording',
	Stopped = 'Stopped',
	Error = 'Error',
}

export type VoiceDictationState =
	| {
			action: VoiceDictationResultAction.Uninitialized;
			error?: string;
			transcription: null;
	  }
	| {
			action: VoiceDictationResultAction.Initializing;
			error?: string;
			transcription: null;
	  }
	| {
			action: VoiceDictationResultAction.Unsupported;
			error: string;
			transcription: null;
	  }
	| {
			action: VoiceDictationResultAction.Recording;
			error?: string;
			transcription: string;
	  }
	| {
			action: VoiceDictationResultAction.Stopped;
			error?: string;
			transcription: string | null;
	  }
	| {
			action: VoiceDictationResultAction.Error;
			error: string;
			transcription: string | null;
	  };

export type WebSpeechToTextAPIAction =
	| { type: 'SET_STATE'; payload: VoiceDictationState }
	| { type: 'SET_INITIALIZING' }
	| { type: 'SET_RECORDING'; payload: { transcription: string } }
	| { type: 'SET_STOPPED' }
	| { type: 'SET_ERROR'; payload: { error: string; transcription?: string | null } }
	| { type: 'UPDATE_TRANSCRIPTION'; payload: { nextTranscription: string } };
